import { Routes } from '@angular/router';
import { KeyphraseExtractionComponent } from './features/keyphrase-extraction/keyphrase-extraction.component';
import { TopicClassificationComponent } from './features/topic-classification/topic-classification.component';
import { AppComponent } from './app.component';
import { MsalGuard } from '@azure/msal-angular';
import { WelcomeComponent } from './features/welcome/welcome.component';


export const routes: Routes = [
  { path: 'home', component: WelcomeComponent, canActivate: [MsalGuard] },
  { path: '', component: WelcomeComponent, canActivate: [MsalGuard] },
  { path: 'keyphrase-extraction', component: KeyphraseExtractionComponent, canActivate: [MsalGuard] },
  { path: 'topic-classification', component: TopicClassificationComponent, canActivate: [MsalGuard] }
];

// export const routes: Routes = [
//   { path: 'home', component: WelcomeComponent },
//   { path: '', component: WelcomeComponent },
//   { path: 'keyphrase-extraction', component: KeyphraseExtractionComponent },
//   { path: 'topic-classification', component: TopicClassificationComponent }
// ];
